import I18n from 'I18n';
import { useEffect, useState } from 'react';
import { fetchAdsSpent } from '../api/adsApi';
import { parseAdSpend } from '../utils/ads';
import { logError } from '../utils/errorHandling';
export const useFetchAdSpendForGoalTarget = (goalTarget, adCampaigns) => {
  const [adSpendPerCampaign, setAdSpendPerCampaign] = useState(new Map());
  const [adSpendLoadingPercentage, setAdSpendLoadingPercentage] = useState(0);
  useEffect(() => {
    if (!goalTarget || adCampaigns === undefined || !adCampaigns.length) return;
    setAdSpendLoadingPercentage(1);
    const {
      adAccountAssetIds,
      startDatetime,
      endDatetime
    } = goalTarget;
    const adCampaignAssetIdsList = adCampaigns.map(campaign => campaign.adCampaignId);
    const adAccountAssetIdsList = adAccountAssetIds ? Array.from(adAccountAssetIds) : [];
    const dataQuery = {
      campaignAssetIds: adCampaignAssetIdsList,
      adAccountAssetIds: adAccountAssetIdsList,
      'date-start': I18n.moment(startDatetime).format('YYYYMMDD'),
      'date-end': I18n.moment(endDatetime).format('YYYYMMDD'),
      status: ['ENABLED', 'PAUSED']
    };
    fetchAdsSpent(dataQuery).then(data => {
      setAdSpendLoadingPercentage(85);
      if (!data) return;
      const parsedAdSpend = parseAdSpend(data, goalTarget);
      setAdSpendPerCampaign(parsedAdSpend);
      setAdSpendLoadingPercentage(99.99);
      setAdSpendLoadingPercentage(100);
    }).catch(logError);
  }, [adCampaigns, goalTarget]);
  return {
    adSpendPerCampaign,
    adSpendLoadingPercentage
  };
};